/* eslint-disable */
export default {
  topic: '會議標題',
} as const;

// @key: @#@"topic"@#@ @source: @#@"Meeting title"@#@
